import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class UndefinedMaterialTariff extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/report/undefinedTariff/material`)
  }

  report(filter, showProgress) {
    return this._request({
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
